import { render, staticRenderFns } from "./TotalSum.vue?vue&type=template&id=33253f00&scoped=true"
import script from "./TotalSum.vue?vue&type=script&lang=ts"
export * from "./TotalSum.vue?vue&type=script&lang=ts"
import style0 from "./TotalSum.vue?vue&type=style&index=0&id=33253f00&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33253f00",
  null
  
)

export default component.exports